export const CADASTRO_ACTION = 'CADASTRAR';
export const EDITAR_ACTION = 'EDITAR';
export const CADASTRADO_COM_SUCESSO = 'Título de Compromisso cadastrado com sucesso';
